export enum ETeamTypeTap {
  MATCHES = 0,
  RESULTS = 1,
  STANDING = 2,
  EQUIPMENT = 3,
}
